<template>
    <div style="position: absolute; right: 0px; bottom: 0px; line-height: 0;padding: 10px 10px;color: white;" :style="{'background-color': backgroundColor}" v-if="ext">{{ext}}</div>
</template>

<script>

export default {
    name: "UploadCard",
    props: ['file'],
    data: () => ({
        file_path: null,
    }),
    mounted() {
        this.fetchPath(this.file);
    },
    watch: {
        file: {
            handler: function (v, old) {
                this.fetchPath(v);
            },
            deep: true,
        },
    },
    methods: {
        fetchPath(f) {
            if (f.status === 'success') {
                this.file_path = f.response !== undefined ? f.response : f.url;
            }
        }
    },
    computed: {
        ext() {
            if (!this.file_path) return null;
            return /(?:\.([^.]+))?$/.exec(this.file_path)[1];
        },
        backgroundColor() {
            switch (this.ext){
                case "pdf": return "#E53935";
                case "doc":
                case "docx": return "#2D92D4";
                case "xls":
                case "xlsx": return "#388E3C";
                default: return "#5e5e5e";
            }
        }
    }
}
</script>



<style scoped>

</style>
